import { createContext } from 'react';
var MenuContext = /*#__PURE__*/createContext({
  inlineCollapsed: false
});
export default MenuContext;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-menu/src/config-provider/MenuContext.js